module.exports = __webpack_public_path__ + "img/reviews-img-2-test.5c70bd84.jpg";